import { render } from "./ViewServices.vue?vue&type=template&id=18f5b815&scoped=true"
import script from "./ViewServices.vue?vue&type=script&lang=js"
export * from "./ViewServices.vue?vue&type=script&lang=js"

import "./ViewServices.vue?vue&type=style&index=0&id=18f5b815&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f5b815"]])

export default __exports__